// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"9b8b4f86","404":"1e086730","498":"31493f80","787":"6f631cf9"}[chunkId] + ".chunk.js";
};